<template>
  <div
    v-if="popShow"
    style="position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.7);z-index: 99;"
    class="flexCenter"
  >
    <div
      style="position:relative;min-width:25.1rem;min-height:12.5rem;background:#ffffff;border-radius:2rem"
    >
      <div style="width:38.5rem;height:30rem;position: relative;">
        <div
          style="width:38.5rem;height:30rem;background:#B5D7F3;border-radius:2rem;position:absolute;left:0.3rem;top:0.3rem"
        ></div>
        <div
          style="width:38.5rem;height:30rem;background:#ffffff;border-radius:2rem;position:absolute;left:0rem;top:0rem"
        >
          <div
            style="font-size:2rem;color:#333333;padding-left:3rem;padding-top:1rem;"
          >
            修改密码
          </div>
          <div style="padding:1.75rem 2.75rem;">
            <div>
              <input
              disabled
                style="width:calc(100% - 4rem );height:4rem;background:#eeeeee;border-radius:1.5rem;padding:0rem 2rem;font-size:1.6rem;border:none;outline:none;color:#333333"
                :value="mobile.substr(0,3)+'****'+mobile.substr(7)"
                placeholder="手机号"
              />
            </div>
            <div style="margin-top:2rem;" class="flexBetween">
              <input
                style="width:calc( 100% - 4rem - 12.6rem);height:4rem;background:#eeeeee;border-radius:1.5rem;padding:0rem 2rem;font-size:1.6rem;border:none;outline:none;color:#333333"
                v-model="sms_code"
                placeholder="短信验证码"
                @keyup.enter="doSub"
              />
              <div class="sendSmsBtn" @click="getSmsCode">
                {{ sms_text }}
              </div>
            </div>
            <div style="margin-top:2rem">
              <input
                style="width:calc(100% - 4rem );height:4rem;background:#eeeeee;border-radius:1.5rem;padding:0rem 2rem;font-size:1.6rem;border:none;outline:none;color:#333333"
                v-model="password"
                type="password"
                placeholder="新密码"
              />
            </div>

            <div style="margin-top:2rem;">
              <div class="loginBtn" @click="doSub">修改密码</div>
            </div>
          </div>
        </div>
      </div>

      <img
        src="../assets/alert_close.png"
        style="width:3.2rem;height:3.2rem;position:absolute;top:-1.6rem;right:-1.6rem;cursor: pointer;"
        @click="hide"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopConfirm',
  props: {},
  data() {
    return {
      login_flag: true,
      send_flag: true,
      sms_code: '',
      mobile: '',
      password: '',
      sms_text: '获取验证码',
      title: '',
      content: 'do something',
      success: null,
      cancle: null,
      popShow: false,
      count_down: 60,
    }
  },
  mounted() {
    let mobile = localStorage.getItem('xiaobi_login_mobile')
    if (mobile) {
      this.mobile = mobile
    }
  },
  methods: {
    doSub() {
      if (!this.login_flag) return

      if (!this.checkPhone(this.mobile)) {
        this.$layer.msg('请输入正确的手机号码')
        return
      }
      if (!this.password) {
        this.$layer.msg('请输入新密码')
        return
      }

      this.login_flag = false

      this.$http
        .post('/api/v2/handwriting/Teacher/updatePasswd', {
          mobile: this.mobile,
          code: this.sms_code,
          passwd: this.password,
        })
        .then((res) => {
          if (res.code == '200') {
            localStorage.removeItem('xiaobi_login_pwd')
            this.$layer.msg('密码修改成功')
            this.popShow = false
          } else {
            this.login_flag = true
          }
        })
    },
    checkPhone(phone) {
      if (phone.length != 11) {
        return false
      } else {
        return true
      }
    },
    checkSmsCode(sms_code) {
      if (sms_code.length != 4) {
        return false
      } else {
        return true
      }
    },
    getSmsCode() {
      if (!this.send_flag) {
        return
      }
      this.send_flag = false
      if (this.checkPhone(this.mobile)) {
        this.$http
          .post('/apipub/handwriting/sms/send', {
            mobile: this.mobile,
            event: 'member_resetpasswd',
          })
          .then((res) => {
            if (res.code == '200') {
              this.$layer.msg('短信验证码已发送')
              this.countDown()
            } else {
              this.send_flag = true
            }
          })
      } else {
        this.$layer.msg('请输入正确的手机号码')
        this.send_flag = true
      }
    },
    countDown() {
      this.sms_text = '重新发送(' + this.count_down + ')'
      this.count_down--
      if (this.count_down > 0) {
        setTimeout(() => {
          this.countDown()
        }, 1000)
      } else {
        this.count_down = 60
        this.sms_text = '重新发送'
        this.send_flag = true
      }
    },
    show(options) {
      this.title = ''
      this.content = 'do something'
      this.success = null
      this.cancle = null
      if (options) {
        this.title = options.title || ''
        this.content = options.content || 'do something'
        this.success = options.success || null
        this.cancle = options.cancle || null
        this.popShow = true
      }
    },
    hide() {
      this.popShow = false
    },
    doCancle() {
      if (typeof this.cancle == 'function') {
        this.cancle()
      }
      this.hide()
    },
    doConfirm() {
      if (typeof this.success == 'function') {
        this.success()
      }
      this.hide()
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cancleBtn {
  font-size: 1.4rem;
  color: #ffffff;
  height: 3.2rem;
  width: 9.4rem;
  text-align: center;
  line-height: 3.2rem;
  border-radius: 1.6rem;
  background: linear-gradient(to right, #ffa143, #ffc11d);
}

.confirmBtn {
  font-size: 1.4rem;
  color: #ffffff;
  height: 3.2rem;
  width: 9.4rem;
  text-align: center;
  line-height: 3.2rem;
  border-radius: 1.6rem;
  background: #2a9bff;
}

.cancleBtn:hover {
  background: linear-gradient(to right, #f38b22, #f38b22);
}

.confirmBtn:hover {
  background: #158ffa;
}

.loginContainer {
  width: 100vw;
  height: 100vh;
  background: url('../assets/login_bg.png') no-repeat;
  background-size: 100% 100%;
}

.sendSmsBtn {
  cursor: pointer;
  width: 11.6rem;
  height: 4rem;
  line-height: 4rem;
  text-align: center;
  font-size: 1.8rem;
  border-radius: 1.5rem;
  color: #ffffff;
  background: linear-gradient(to right, #ffa143, #ffc11d);
}

.sendSmsBtn:hover {
  background: linear-gradient(to right, #f38b22, #f38b22);
}

.loginBtn {
  cursor: pointer;
  width: 33rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
  font-size: 2.2rem;
  border-radius: 2rem;
  color: #ffffff;
  background: #2a9bff;
}

.loginBtn:hover {
  background: #158ffa;
}
</style>
